import jQuery from 'jquery';
import Flickity from 'flickity';
import Viewport from './Viewport';

// Register our jquery version with Flickity.
Flickity.setJQuery(jQuery);

const sliderConfig = {
  arrowShape: 'M24.5,51.6v-3.2l19.6-19.6l3.2,3.2L31.5,47.8h44.1v4.5H31.5L47.2,68l-3.2,3.2L24.5,51.6z',
  wrapAround: true,
  groupCells: true,
  // prevNextButtons: false,
};

export default class FlickityHomePillars {
  constructor(element) {
    this.element = element;
    this.$element = jQuery(element);

    // Sanity check for slider functionality.
    if (this.shouldBuildSlider) {
      Flickity.setJQuery(jQuery);
      this.viewport = new Viewport();
      this.viewport.onChange(this.update.bind(this));
      this.viewport.update();
      this.update();
    }

    // set component ready
    this.ready();
  }

  update() {
    this.buildSlider();
  }

  buildSlider() {
    if (!this.isSlider) {
      this.slider = new Flickity(this.sliderElement, sliderConfig);
      this.isSlider = true;
    }
  }

  ready() {
    this.$element.addClass('ready');
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.view-content');
  }

  get slides() {
    return this.sliderElement.childNodes;
  }
}
